import { render, staticRenderFns } from "./QueriesAllList.vue?vue&type=template&id=16a77fb3"
import script from "./QueriesAllList.vue?vue&type=script&lang=js"
export * from "./QueriesAllList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports